import { render, staticRenderFns } from "./PaymentScreen.vue?vue&type=template&id=e947b0a6&scoped=true&"
import script from "./PaymentScreen.vue?vue&type=script&lang=js&"
export * from "./PaymentScreen.vue?vue&type=script&lang=js&"
import style0 from "./PaymentScreen.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PaymentScreen.vue?vue&type=style&index=1&id=e947b0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e947b0a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCheckbox,VCol,VContainer,VDivider,VForm,VRow,VSelect,VTextField})
